import { gql } from '@apollo/client/core';

export const getEventTypes = gql`
  query getEventTypes {
    eventTypes {
      id: type
      type
      priority
      uniqueID
    }
  }
`;

/**
 * Backend-authoritative (type, status) -> human label reference table ("qx.vEventStatus").
 * Scoped to the (type, status) pairs actually present in the caller's event list rather than
 * fetched in full, so this stays cheap as the reference table grows.
 */
export const GQL_GET_EVENT_STATUS_LABELS = gql`
  query GQL_GET_EVENT_STATUS_LABELS($where: vEventStatuses_bool_exp!) {
    vEventStatuses(where: $where) {
      type
      status
      comment
    }
  }
`;
